import { handleActions } from 'redux-actions';
import { conflictsRoutine } from './routines';

// autoApply: { type: 'patient', id, serverEntity } | null
//   — entité serveur à appliquer directement dans FicheClinique (bypass memoization)
// remountKeys: { contactId: timestamp }
//   — signale à FicheClinique de remonter le FormContactRow d'un contact
const initialState = {
  autoApply: null,
  remountKeys: {},
};

export const conflictsReducer = handleActions(
  {
    // Patient conflict : stocke l'entité serveur pour application directe dans FicheClinique
    [conflictsRoutine.ADD]: (state, action) => {
      const { type, id, serverEntity } = action.payload;
      if (type !== 'patient') return state;
      return { ...state, autoApply: { type, id, serverEntity } };
    },

    // Contact conflict : bumpe remountKeys pour forcer le remount du formulaire
    [conflictsRoutine.RESOLVE]: (state, action) => {
      const { type, id, strategy } = action.payload;
      if (strategy === 'use_server' && type === 'contact') {
        return { ...state, remountKeys: { ...state.remountKeys, [id]: Date.now() } };
      }
      return state;
    },

    // FicheClinique a appliqué l'entité serveur : on efface
    [conflictsRoutine.APPLIED]: (state) => ({ ...state, autoApply: null }),
  },
  initialState
);
